import React from 'react';

export function StepNoteLabel() {
  return <>Poznámka</>;
}
